module.exports = __webpack_public_path__ + "img/state5_xiangqing_biaoti.4c039d16.png";